/**
 * src/portal.js - Logic for the Multiverse Portal
 * Handles theme synchronization and portal interactions.
 */

function setupPortalTheme() {
    const hour = new Date().getHours();
    const body = document.getElementById('main-body');
    if (!body) return;
    
    // Clear previous themes
    body.classList.remove('theme-morning', 'theme-afternoon', 'theme-night');
    
    if (hour >= 6 && hour < 14) {
        body.classList.add('theme-morning');
    } else if (hour >= 14 && hour < 20) {
        body.classList.add('theme-afternoon');
    } else {
        body.classList.add('theme-night');
    }
}

// Global bootstrap
document.addEventListener('DOMContentLoaded', () => {
    setupPortalTheme();
    console.log("Portal Multiverso: Inicializado v1.1.0");
});
